import { all, take, put, takeEvery, call } from 'redux-saga/effects';
import { toSuccess, toError } from 'react-async-client';
import { eventChannel } from 'redux-saga';
import { assoc } from 'ramda';

import { LOGOUT, GET_USER, LOGIN, PASSWORD_CONFIRM, POST_LINK_REGISTRATION } from 'constants/actionTypes';
import { logout, login as loginAction } from 'actions/userActions';
import { handleTokenChange } from 'utils/token';
import { getUser } from 'actions/asyncActions';

function localStorageTokenListener() {
    return eventChannel(emitter => {
        const waitAccessEvent = (event) => {
            event.key === 'token' && (event.newValue !== event.oldValue) && emitter(event.newValue || '');
        };
        window.addEventListener('storage', waitAccessEvent);

        return () => window.removeEventListener(waitAccessEvent);
    })
}

function* toggleLogin() {
    const token = yield call(localStorageTokenListener);
    yield takeEvery(token, function* (token) {
        const action = loginAction.success({ token });
        yield put(token ? assoc('requestAction', {}, action) : logout());
    });
}

function* loginFlow() {
    while (true) {
        yield take([toSuccess(LOGIN), toSuccess(PASSWORD_CONFIRM), toSuccess(POST_LINK_REGISTRATION)]);
        yield put(getUser());

        yield take([LOGOUT, toError(GET_USER)]);
        handleTokenChange(null);
        yield put(getUser.reset());
    }
}

export default function* login() {
    yield all([
        loginFlow(),
        toggleLogin(),
        takeEvery([toSuccess(LOGIN), toSuccess(PASSWORD_CONFIRM), toSuccess(POST_LINK_REGISTRATION)], function doRedirect(action) {
            handleTokenChange(action.payload.token);
        }),
    ]);
}
